// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const HorizontalRuleIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="HorizontalRuleIcon" ref={forwardedRef} {...props}>
      <path d="M17.997 10.75h-16v-1.5h16z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const HorizontalRuleIcon = /* @__PURE__ */ Object.assign(
  HorizontalRuleIconComponent,
  { displayName: 'HorizontalRuleIcon' },
);
